<script>
import options from './FormInputSelect.options'
const componentOptions = options
export default componentOptions
</script>

<template>

  <div class="be-form__input-wrapper be-form__input-select">

    <div class="be-form__input-and-label-wrapper" :class="{
        ValidationRequired: isRequired,
        'validation-error': isValidationError,
        'validation-success': isValid,
        'disabled': disabled
      }">

      <label :for="inputName" class="be-form__input-label">
        {{ label }}
        {{ isRequired ? ' *' : '' }}
      </label>

      <select class="be-form__input" 
          :id="inputName" 
          :disabled="disabled"
          v-model="localValue" 
          :aria-describedby="`${inputName}__desc`"
          :aria-invalid="isValidationError"
          @change="formLink"
          :class="{ValidationRequired: isRequired, 
                  'validation-error' :isValidationError, 
                  'validation-success' :isValid,
                  }" >
        <option value="" disabled>{{ placeholder }}</option>
          <template v-for="(option, index) in selectOptions" :key="index">
            <option :value="option.value">
              {{ option.name }}
            </option>
          </template>
      </select>
    </div>

    <div aria-live="assertive" v-if="isValidationError && !disabled">
      <p class="be-form__input-validation-error" role="alert">
        {{ errorMessageLabel }}
      </p>
    </div>

    <p class="be-form__input-helptext" :id="`${inputName}__desc`" v-if="helpMessageLabel && (!isValidationError && !disabled)">
      {{ helpMessageLabel }}
    </p>
    
    <div class="be-form__input-icons-wrapper">

      <div class="be-form__input-select-chevron">
        <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6 9 6 6 6-6" stroke="#1E2B24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>

      <div v-if="isValid && !disabled && !isValidationError">
        <svg role="presentation" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="#32936F" fill-opacity=".24"/><path d="M14.473 6.807a.667.667 0 0 0-.946 0L8.56 11.78 6.473 9.687a.681.681 0 1 0-.946.98l2.56 2.56a.666.666 0 0 0 .946 0l2.72-2.72 2.72-2.72a.666.666 0 0 0 0-.98Z" fill="#017F40"/></svg>
      </div>

    </div>

  </div>
</template>
